import React from 'react';
import { Link } from 'react-router-dom';
import './landing/landing.css';

const NotFound = () => (
  <div className="lp flex min-h-screen flex-col">
    <header className="mx-auto w-full max-w-6xl px-4 py-6 sm:px-6 lg:px-8">
      <Link to="/" className="lp-display text-2xl">
        webspector<span className="text-[var(--lp-lime)]">.</span>
      </Link>
    </header>
    <main className="mx-auto flex w-full max-w-6xl flex-1 flex-col justify-center px-4 pb-24 sm:px-6 lg:px-8">
      <p className="lp-kicker">Error 404</p>
      <h1 className="lp-display mt-5 max-w-3xl text-[clamp(2.6rem,6.5vw,5rem)]">No encontramos esta página.</h1>
      <p className="mt-8 max-w-xl text-lg leading-relaxed text-[var(--lp-muted)]">
        La dirección no existe o ha cambiado. Vuelve al inicio y comprueba gratis si la IA recomienda tu negocio.
      </p>
      <div className="mt-10">
        <Link to="/" className="lp-btn">
          Ir al inicio
        </Link>
      </div>
    </main>
  </div>
);

export default NotFound;
